/* jshint esversion: 6 */
/* jshint esversion: 8 */
/* jshint esversion: 9 */
/* jshint esversion: 11 */
/* jshint ignore:start */
import { useContext, useEffect, useState } from 'react';
import { MyContext } from '../../Context/MyProvider';
import secureLocalStorage from 'react-secure-storage';
import axios from 'axios';
import ImageLoad from './ImageLoad';
import { GoogleMap, Marker, useLoadScript } from "@react-google-maps/api";
import { showToast } from '../../showTost';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import * as turf from '@turf/turf';
import MapPin from "../../Icon/map.svg";
const SavAddress = () => {

  const { t } = useTranslation();
  const { BaseUrl, MapKey, setIsShowAdsBox, AddressRef, setSelectAds } = useContext(MyContext);

  const [loading, setLoading] = useState(true);
  const [ispage, setIsPage] = useState("Save");
  const [addreslist, setAddresList] = useState([]);
  const [mapcoords, setMapCoords] = useState({ lat: "", long: "" });
  const [addressdata, setAddressData] = useState({ address: "", hno: "", city: "", pincode: "", landmark: "", type: "" });
  const [isedit, setIsEdit] = useState("0");
  const [apiloading, setApiLoding] = useState(false);
  const [istypeadd, setIsTypeAdd] = useState("");

  const Location = useLocation();
  const IsShowBtn = Location.pathname.startsWith("/checkout");

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: MapKey
  });

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      position => {
        const lat = position.coords.latitude;
        const long = position.coords.longitude;
        setMapCoords({ lat, long });
      }
    );
    handleGetAddres();
  }, []);


  const handleGetAddres = () => {
    const uid = secureLocalStorage.getItem("Userid");

    axios.post(`${BaseUrl}tcapi/s_address_list.php`, { uid })
      .then((res) => {
        const AddressList = res.data.AddressList;
        setAddresList(AddressList);
        setLoading(false);
      })
      .catch((error) => {
        console.error("s_address_list.php", error);
      });
  };

  const handleMapClick = (event) => {
    const lat = event.latLng.lat();
    const long = event.latLng.lng();
    setMapCoords({ lat, long });
    HandleGetGoogleAddress(lat, long, "");
  };

  const HandleGetGoogleAddress = async (lat, lng, data) => {

    setIsPage("New");
    const geocoder = new window.google.maps.Geocoder();

    geocoder.geocode({ location: { lat, lng } }, (results, status) => {
      if (status === 'OK' && results[0]) {
        const components = results[0].address_components;

        const getComponent = (type) => {
          const comp = components.find(c => c.types.includes(type));
          return comp?.long_name || '';
        };

        const thoroughfare = getComponent('route');
        const subLocality = getComponent('sublocality');
        const locality = getComponent('locality');
        const subAdminArea = getComponent('administrative_area_level_2');
        const postalCode = getComponent('postal_code');
        const adminArea = getComponent('administrative_area_level_1');

        const fulladdress =
          `${thoroughfare ? thoroughfare + ', ' : ''}` +
          `${subLocality ? subLocality + ', ' : ''}` +
          `${locality ? locality + ', ' : ''}` +
          `${subAdminArea ? subAdminArea + ', ' : ''}` +
          `${postalCode ? postalCode + ', ' : ''}` +
          `${adminArea || ''}`;

        if (data) {
          setAddressData({ city: locality, pincode: postalCode, address: fulladdress, hno: data.hno, landmark: data.landmark, type: data.type });
        } else {
          setAddressData({ ...addressdata, city: locality, pincode: postalCode, address: fulladdress });
        }
      }
    });
  };

  const handleAddAddress = () => {
    const { address, hno, landmark, type, city, pincode } = addressdata;

    if (!hno || !landmark || !type) {
      showToast({ title: t('Please fill all details !!'), id: "info" });
      return;
    }

    setApiLoding(true);
    const uid = secureLocalStorage.getItem("Userid");

    const ApiData = {
      uid, address, city, pincode,
      houseno: hno,
      landmark, type,
      lat_map: mapcoords.lat,
      long_map: mapcoords.long,
      aid: isedit
    };

    axios.post(`${BaseUrl}tcapi/s_address_user.php`, ApiData)
      .then((res) => {
        const Toastid = res.data.ResponseCode === "200" ? "success" : "error";
        showToast({ title: res.data.ResponseMsg, id: Toastid });
        if (res.data.ResponseCode === "200") {
          setIsPage("Save");
          handleGetAddres();
        }
        setApiLoding(false);
      })
      .catch((error) => {
        console.error("s_address_user.php", error);
      });

  };

  const HandleEditAddress = (item) => {
    setIsEdit(item.id);
    handleCheckType(2, item.type);
    setIsPage("New");
    HandleGetGoogleAddress(Number(item.lat_map), Number(item.long_map), item);
  };

  const handleSelectType = (item, IsAdded) => {
    !IsAdded && setAddressData({ ...addressdata, type: item });
  };

  const handleCheckType = (index, type) => {
    if (index === 1) {
      HandleGetGoogleAddress(mapcoords.lat, mapcoords.long, "");
      const Type = ["Home", "Office"];
      const FilterAddress = addreslist?.map(item => {
        if (Type.includes(item.type)) {
          return item.type;
        }
        return null;
      }).filter(Boolean);
      setIsTypeAdd(FilterAddress);
    } else {
      const FilterAddress = addreslist.map(item => {
        if (item.type !== type) {
          return item.type;
        }
        return null;
      }).filter(Boolean);
      setIsTypeAdd(FilterAddress);
    }

  };

  const handleClearState = () => {
    setIsPage("Save");
    setAddressData({ address: "", hno: "", city: "", pincode: "", landmark: "", type: "" });
    setIsEdit(0);
  };

  const handleClose = () => {
    AddressRef.current.classList.remove('addres_menu_open');
    setTimeout(() => {
      setIsShowAdsBox(false);
    }, 500);
    handleClearState();
  };

  const HandleSelectAds = (item) => {
    const Coordinates = secureLocalStorage.getItem("coordinates");
    if (Coordinates) {

      const zones = JSON.parse(Coordinates);
      const userPoint = turf.point([item.lat_map, item.long_map]);
      let isInsideAnyZone = false;
      let matchedZone = null;
      for (const zone of zones) {
        const coords = zone.coordinates.map(p => [p.lng, p.lat]);
        const polygon = turf.polygon([coords]);
        const inside = turf.booleanPointInPolygon(userPoint, polygon);
        if (inside) {
          isInsideAnyZone = true;
          matchedZone = zone;
          break;
        }
      }
    }
    setSelectAds(item);
    handleClose();
  };

  return (
    <div>

      {ispage === "Save" && <div className="savaddres_page">

        <div className="flex items-center gap-[10px]">
          <button onClick={handleClose}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M13.414 12L18.707 6.70695C19.098 6.31695 19.098 5.68301 18.707 5.29301C18.316 4.90201 17.684 4.90201 17.293 5.29301L12 10.586L6.70701 5.29301C6.31601 4.90201 5.68401 4.90201 5.29301 5.29301C4.90201 5.68301 4.90201 6.31695 5.29301 6.70695L10.586 12L5.29301 17.293C4.90201 17.683 4.90201 18.3169 5.29301 18.7069C5.48801 18.9019 5.74401 19 6.00001 19C6.25601 19 6.51201 18.9019 6.70701 18.7069L12 13.414L17.293 18.7069C17.488 18.9019 17.744 19 18 19C18.256 19 18.512 18.9019 18.707 18.7069C19.098 18.3169 19.098 17.683 18.707 17.293L13.414 12Z" fill="#25314C" />
            </svg>
          </button>
          <h1 className="font-bold text-[20px]">{t("Saved Addresses")}</h1>
        </div>

        <div className="w-full h-full mt-[20px] scroll_container">
          {loading
            ? <div className="h-full flex items-center justify-center">
              <div className="loader"></div>
            </div>
            : <div className="h-full">
              {addreslist?.length >= 1
                ? addreslist?.map((item, index) => {
                  return <div key={index} className="addres_box">
                    <ImageLoad BaseUrl={BaseUrl} url={item.address_image} CustomeStyle={"w-[40px] border-[1px] p-[8px] rounded-[10px]"} />
                    <div>
                      <h1 className="font-[600] text-[17px]">{item.type}</h1>
                      <p className="text-[rgba(2,6,12,.6)] font-[500] text-[15px] leading-4">{item.hno}, {item.landmark}, {item.address}</p>

                      <div className="mt-[10px] flex items-center gap-[30px]">
                        {IsShowBtn && <button onClick={() => HandleSelectAds(item)} className="font-[600] text-green-500 text-[15px]">{t("SELECT")}</button>}
                        <button onClick={() => HandleEditAddress(item)} className="font-[600] text-green-500 text-[15px]">{t("EDIT")}</button>
                      </div>

                    </div>
                  </div>
                })
                : <div className="h-full flex items-center justify-center">
                  <h1 className="font-bold text-[17px] text-gray-600">{t("Address list not found !!")}</h1>
                </div>
              }
            </div>}
        </div>

        <button onClick={() => handleCheckType(1)} className="button bg-[--bgcolor] rounded-[10px]">{t("ADD NEW ADDRESS")}</button>

      </div>}

      {ispage === "New" && <div className="newaddres_page">

        <div className="flex items-center gap-[10px]">
          <button onClick={handleClearState}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M21.7501 12C21.7501 12.414 21.4141 12.75 21.0001 12.75H4.81115L10.5311 18.47C10.8241 18.763 10.8241 19.238 10.5311 19.531C10.3851 19.677 10.1931 19.751 10.0011 19.751C9.80909 19.751 9.61706 19.678 9.47106 19.531L2.47106 12.531C2.40206 12.462 2.3472 12.3791 2.3092 12.2871C2.2332 12.1041 2.2332 11.8971 2.3092 11.7141C2.3472 11.6221 2.40206 11.539 2.47106 11.47L9.47106 4.46999C9.76406 4.17699 10.2391 4.17699 10.5321 4.46999C10.8251 4.76299 10.8251 5.23803 10.5321 5.53103L4.81213 11.251H21.0001C21.4141 11.25 21.7501 11.586 21.7501 12Z" fill="#25314C" />
            </svg>
          </button>
          <h1 className="font-bold text-[20px]">{t("New Addresses")}</h1>
        </div>

        <div className="mt-[20px]">

          <div className="google_map">
            {isLoaded && <GoogleMap
              center={{ lat: Number(mapcoords.lat), lng: Number(mapcoords.long) }}
              zoom={15}
              onClick={handleMapClick}
              options={{
                mapTypeControl: false,
                fullscreenControl: false,
                streetViewControl: false,
                zoomControl: false,
              }}
            >
              <Marker icon={{
                url: MapPin,
                scaledSize: new window.google.maps.Size(50, 50),
              }} position={{ lat: Number(mapcoords.lat), lng: Number(mapcoords.long) }} />
            </GoogleMap>}
          </div>

          <div className="mt-[20px] input_box">

            <input type="text" value={addressdata.address} readOnly placeholder={t("Address")} />
            <input type="text" value={addressdata.hno} onChange={(e) => setAddressData({ ...addressdata, hno: e.target.value })} placeholder={t("House / Flat / Block No.")} />
            <input type="text" value={addressdata.landmark} onChange={(e) => setAddressData({ ...addressdata, landmark: e.target.value })} placeholder={t("Landmark")} />

          </div>

          <div className="flex items-center gap-[10px] my-[10px]">
            {["Home", "Office", "Other"].map((item, index) => {
              const IsAdded = istypeadd?.includes(item);
              const IsSelect = item === addressdata.type;
              return <button key={index} onClick={() => handleSelectType(item, IsAdded)} className={`w-full border-[1px] py-[8px] duration-[.5s] rounded-[10px] ${IsAdded ? "cursor-default" : ""} ${IsSelect ? "bg-[--bgcolor]" : ""}`}>
                <h1 className={`font-[600] ${IsSelect ? 'text-white' : IsAdded ? "text-gray-500" : ""}`}>{t(item)}</h1>
              </button>
            })}
          </div>

          <button onClick={handleAddAddress} className="button bg-[--bgcolor] rounded-[10px]">
            {apiloading
              ? <div className="btn_loader mx-auto"></div>
              : <span>{t("Continue")}</span>}
          </button>

        </div>

      </div>
      }

    </div >
  )
}

export default SavAddress
/* jshint ignore:end */